var _defs, _clipPath, _path, _path2, _circle, _path3, _g, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use0, _use1, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 700,
    viewBox: "-2100 -1470 4200 2940",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "j",
    fillRule: "evenodd",
    d: "M-31.5 0h33a30 30 0 0 0 30-30v-10a30 30 0 0 0-30-30h-33zm13-13h19a19 19 0 0 0 19-19v-6a19 19 0 0 0-19-19h-19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "M0 0h63v-13H12v-18h40v-12H12v-14h48v-13H0z",
    transform: "translate(-31.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "M-26.25 0h52.5v-12h-40.5v-16h33v-12h-33v-11H25v-12h-51.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l",
    d: "M-31.5 0h12v-48l14 48h11l14-48V0h12v-70H14L0-22l-14-48h-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    fillRule: "evenodd",
    d: "M0 0a31.5 35 0 0 0 0-70A31.5 35 0 0 0 0 0m0-13a18.5 22 0 0 0 0-44 18.5 22 0 0 0 0 44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    fillRule: "evenodd",
    d: "M-31.5 0h13v-26h28a22 22 0 0 0 0-44h-40zm13-39h27a9 9 0 0 0 0-18h-27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "M-15.75-22C-15.75-15-9-11.5 1-11.5s14.74-3.25 14.75-7.75c0-14.25-46.75-5.25-46.5-30.25C-30.5-71-6-70 3-70s26 4 25.75 21.25H13.5c0-7.5-7-10.25-15-10.25-7.75 0-13.25 1.25-13.25 8.5-.25 11.75 46.25 4 46.25 28.75C31.5-3.5 13.5 0 0 0c-11.5 0-31.55-4.5-31.5-22z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    id: "p",
    transform: "scale(31.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    id: "q",
    transform: "scale(26.25)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    id: "u",
    transform: "scale(21)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    id: "r",
    transform: "scale(15)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    id: "v",
    transform: "scale(10.5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "n"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-31.5 0v-70h63V0zM0-47v12h31.5v-12z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    clipPath: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5-35h26.5v10H5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5-35h10V0h-10z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 0c0-10 0-32-15-32H-6c22 0 22 22 22 32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M0-1v1h.5",
    transform: "rotate(18 0 -1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    transform: "rotate(-72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    transform: "rotate(216)"
  })))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 735
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#009440",
    d: "M-2100-1470h4200v2940h-4200z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcb00",
    d: "M-1743 0 0 1113 1743 0 0-1113Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 735,
    fill: "#302681"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-2205 1470a1785 1785 0 0 1 3570 0h-105a1680 1680 0 1 0-3360 0z",
    clipPath: "url(#h)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#009440",
    transform: "translate(-420 1470)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    y: -1697.5,
    transform: "rotate(-7)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    y: -1697.5,
    transform: "rotate(-4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j",
    y: -1697.5,
    transform: "rotate(-1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    y: -1697.5,
    transform: "rotate(2)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    y: -1697.5,
    transform: "rotate(5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    y: -1697.5,
    transform: "rotate(9.75)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    y: -1697.5,
    transform: "rotate(14.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    y: -1697.5,
    transform: "rotate(17.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    y: -1697.5,
    transform: "rotate(20.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n",
    y: -1697.5,
    transform: "rotate(23.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    y: -1697.5,
    transform: "rotate(26.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    y: -1697.5,
    transform: "rotate(29.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o",
    y: -1697.5,
    transform: "rotate(32.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o",
    y: -1697.5,
    transform: "rotate(35.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    y: -1697.5,
    transform: "rotate(38.5)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: -600,
    y: -132
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: -535,
    y: 177
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    x: -625,
    y: 243
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r",
    x: -463,
    y: 132
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    x: -382,
    y: 250
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    x: -404,
    y: 323
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 228,
    y: -228
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 515,
    y: 258
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    x: 617,
    y: 265
  })), _use0 || (_use0 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    x: 545,
    y: 323
  })), _use1 || (_use1 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    x: 368,
    y: 477
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    x: 367,
    y: 551
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    x: 441,
    y: 419
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    x: 500,
    y: 382
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    x: 365,
    y: 405
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    x: -280,
    y: 30
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    x: 200,
    y: -37
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    y: 330
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    x: 85,
    y: 184
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    y: 118
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    x: -74,
    y: 184
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r",
    x: -37,
    y: 235
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    x: 220,
    y: 495
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    x: 283,
    y: 430
  })), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    x: 162,
    y: 412
  })), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: -295,
    y: 390
  })), _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v",
    y: 575
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBr);
export default __webpack_public_path__ + "static/media/br.5e227b1777b6ae8a68100a28d15130f4.svg";
export { ForwardRef as ReactComponent };